import { useTranslation } from 'react-i18next';

import s from '../../styles.module.scss';

import type { FC } from 'react';

const TemporaryHoldBadge: FC = () => {
  const { t } = useTranslation();

  return (
    <div data-cy="temporary-hold-tag" className={s.badge}>
      <p>{t('labels.temporaryHold')}</p>
    </div>
  );
};
export default TemporaryHoldBadge;
